"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "Options" */ './lazyIndex');
});
exports.lazyMoveInboxRule = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.moveInboxRule; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/index.js
// module id = 5174
// module chunks = 2